<template>
  <div class="collectionDetailGallery"
    :style="pageSetting">
    <button type="button" class="btnClose" @click.stop="close"></button>

    <div v-if="groupItemGallery" class="frame">
      <div v-if="hasGalleryItems" class="imageList">
        <swiper
          :options="swiperOptions"
          ref="imageList"
          class="imageWrapper">

          <!-- 세부아이템 클릭 -->
          <template v-if="groupItemGallery.type === 'item'">
            <swiper-slide
              v-for="(item, index) in groupItemGallery.imageList"
              :key="index">

              <div class="img">
                <img :src="item.image" alt="">
              </div>

              <!-- <div class="name">
                {{ item.collectionItemName[lang] }}
              </div> -->
            </swiper-slide>
          </template>

          <!-- 분류명 클릭 -->
          <template v-else-if="groupItemGallery.type === 'class'">
            <swiper-slide
              v-for="(classItem, index) in groupItemGallery.classList"
              :key="`${index}_${classItem.collectionClassId}`">

              <div
                class="classImages"
                :class="{multiple: classItem.items.length > 1}">

                <div
                  v-for="item in classItem.items"
                  :key="item.subItemId"
                  class="classItemImage">

                  <div class="img">
                    <img
                      :src="getSelectedImage(item)"
                      alt="">
                  </div>

                  <div
                    v-if="item.imageList.length > 1"
                    class="thumbnailList">

                    <button
                      v-for="(image, index) in item.imageList"
                      :key="index"
                      type="button"
                      class="thumbnail"
                      :class="{active: getSelectedImageIndex(item) === index}"
                      @click.stop="selectItemImage(item, index)">

                      <img :src="image" alt="">
                    </button>

                  </div>
                </div>

              </div>
            </swiper-slide>
          </template>

        </swiper>

        <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>

        <div v-if="imgIndicator" class="imgIndicator">
          <span
            v-for="img in imgIndicator.length"
            :key="img"
            class="dot"
            :style="{backgroundColor: imgIndicator.color}">
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

export default {
  name: 'DetailGroupItemGallery',
  props: [
    'locale',
    'lang',
    'pageId',
  ],
  components: {
    swiper,
    swiperSlide
  },
  computed: {
    groupItemGallery () {
      return this.$store.getters['collection/getDetailGroupItemGallery']
    },
    hasGalleryItems () {
      if (!this.groupItemGallery) return false
      if (this.groupItemGallery.type === 'class') {
        return this.groupItemGallery.classList &&
          this.groupItemGallery.classList.length > 0
      }
      return this.groupItemGallery.imageList &&
        this.groupItemGallery.imageList.length > 0
    },
    getPointColor () {
      return this.$store.getters['collection/getPointColor']
    },
    collectionSetting () {
      return this.$store.getters['collection/getCollectionSetting']
    },
    pageSetting () {
      const setting = this.collectionSetting
      const itemDetail = this.itemInfo && this.itemInfo.attribute
      return  {
        backgroundColor: setting.backgroundColor,
        color: itemDetail && itemDetail.detailColorActive ? itemDetail.detailTextColor : ''
      }
    },
    itemInfo () {
      const collectionItemId = this.collectionItemId
      return collectionItemId && this.$store.getters['collection/getItemByItemId'](collectionItemId)
    },
    imgIndicator () {
      if (!this.groupItemGallery) return null
      if (this.groupItemGallery.type === 'class') return null

      const length = this.groupItemGallery.imageList.length

      return length > 1
        ? {
            length,
            color: this.getPointColor
          }
        : null
    },
  },
  mounted () {
    this.$nextTick(() => {
      const swiper = this.$refs.imageList.swiper

      if (swiper) {
        swiper.slideTo(this.groupItemGallery.startIndex || 0, 0)
      }
    })
  },
  data () {
    return {
      selectedImageIndexes: {},

      swiperOptions: {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        loop: false,
        autoplay: false,
        threshold: 80,
        slidesPerView: 1
      }
    }
  },
  methods: {
    getSelectedImageIndex (item) {
      return this.selectedImageIndexes[item.subItemId] || 0
    },

    getSelectedImage (item) {
      const index = this.getSelectedImageIndex(item)
      return item.imageList[index]
    },

    selectItemImage (item, index) {
      this.$set(
        this.selectedImageIndexes,
        item.subItemId,
        index
      )
    },

    close () {
      this.$store.commit('collection/setDetailGroupItemGallery', null)
    }
  }
}
</script>
